module.exports = __webpack_public_path__ + "img/app-installation-secondary.945030c3.png";